import React from 'react';

const DynamicBackground = ({ children }) => {
  return (
    <div className="wood-container">
      {children}
    </div>
  );
};

export default DynamicBackground;
